// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>
<div class="box">
  <sub-header header="'Transfer placement'"></sub-header>

    <missing-access-warning
      missing-access="CST_DEPOSIT_ACCOUNT_READ">
    </missing-access-warning>

    <!-- Operation form -->

    <form name="\$ctrl.transactionForm">

      <div class="alert alert--danger" ng-if="\$ctrl.warningMessage">
        <span>{{\$ctrl.warningMessage}}</span>
      </div>

      <table class="misc-transaction__table table">
        <tbody>
        <tr>
          <td>1.</td>
          <td>Source product</td>
          <td>
            <selectize options="\$ctrl.casaProducts"
                       config="\$ctrl.casaProductsSelectizeConfig"
                       ng-model="\$ctrl.commandInput.sourceProductId"
                       required>
            </selectize>
          </td>
        </tr>
        <tr>
          <td>2.</td>
          <td>Amount</td>
          <td><cash ng-model="\$ctrl.commandInput.amount"
                  min="0.01"
                  ng-required="true"></cash></td>
        </tr>
        <tr>
          <td>3.</td>
          <td>Remarks</td>
          <td>
            <input
              type="text"
              ng-model="\$ctrl.commandInput.remarks"
              size="1024"
              required>
          </td>
        </tr>
        </tbody>
      </table>
      <div class="summary-actions">
        <button class="btn btn-warning" type="button"
                ng-click="\$ctrl.redirectBack()">
          Cancel
        </button>
        <button class="btn btn-success" type="button"
                ng-click="\$ctrl.doTransfer()"
                ng-disabled="\$ctrl.transactionForm.\$invalid">
          Transfer
        </button>
      </div>
    </form>

</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/term-deposits/transfer-placement/transfer-placement.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;